import util from '../utils/util'
import { baseApi } from '@/v2/utils/api.js'
import AliOSS from 'ali-oss'
import { xDraw } from '@/v2/utils/draw.js'
import utilOld from '@/utils/util'
import exam_enum from '@/utils/exam_enum'

export const baseData = {
  setConfigOptions (resp) {
    if (!resp.body) return resp
    for (let index = 0; index < resp.body.length; index++) {
      const item = resp.body[index];
      item.configDescOptions = []
      const desc = item.configTypeDesc ? item.configTypeDesc : ''
      if (desc && desc.indexOf('$') === -1) continue
      // 配置规则的选项解析
      const list = desc.split('$')
      for (let cIndex = 0; cIndex < list.length; cIndex++) {
        const element = list[cIndex];
        const infos = element.split('-')
        if (infos.length <= 1) continue
        item.configDescOptions.push({
          name: infos[1],
          value: infos[0]
        })
      }
    }
  },
  setOptionList: function (configList) {
    for (let index = 0; index < configList.length; index++) {
      const item = configList[index];
      item.options = []
      const desc = item.configTypeDesc ? item.configTypeDesc : ''
      if (desc && desc.indexOf('$') === -1) continue
      // 配置规则的选项解析
      const list = desc.split('$')
      for (let cIndex = 0; cIndex < list.length; cIndex++) {
        const element = list[cIndex];
        const infos = element.split('-')
        if (infos.length <= 1) continue
        item.options.push({
          name: infos[1],
          value: infos[0]
        })
      }
    }
  },
  // 获取科目id（根据课程id）
  getSubjectIdByCourseId (courseId) {
    const subjectList = [
      {
        id: '1',
        name: '语文',
        list: ['1', '10', '26', '50']
      },
      {
        id: '2',
        name: '数学',
        list: ['2', '11', '27', '51']
      },
      {
        id: '3',
        name: '英语',
        list: ['3', '12', '28', '52']
      },
      {
        id: '4',
        name: '物理',
        list: ['13', '29', '55']
      },
      {
        id: '5',
        name: '化学',
        list: ['14', '30', '56']
      },
      {
        id: '6',
        name: '生物',
        list: ['15', '31']
      },
      {
        id: '7',
        name: '政治',
        list: ['4', '16', '32', '59']
      },
      {
        id: '8',
        name: '历史',
        list: ['17', '33', '60']
      },
      {
        id: '9',
        name: '地理',
        list: ['18', '34']
      },
      {
        id: '12',
        name: '信息技术',
        list: ['6', '20', '35', '57']
      },
      {
        id: '21',
        name: '日语',
        list: ['43', '44']
      },
      {
        id: '22',
        name: '俄语',
        list: ['45', '46']
      },
      {
        id: '26',
        name: '藏语',
        list: ['117', '118', '119']
      },
    ]
    const subject = subjectList.find(s => s.list.includes(courseId + ''))
    return subject ? subject.id : (courseId + '').includes('0') ? '0' : ''
  },
  getNavigators: () => {
    const filterList = [
      'Region-Exam-Single', // 区域 - 考试列表
      'Region-Exam-Wuhen', // 区域 - 考试批改
      'Region-Exam-Gaokao', // 区域 - 新高考报告
      'Region-Data', // 区域 - 大数据中心
      'Region-System',// 区域 - 阅卷帐号
      'Region-Answer-Sheet-Production', // 区域 - 答题卡制作
      'City-Exam-Single', // 省 - 考试列表
      'City-Exam-Wuhen', // 省 - 考试批改
      'City-Exam-Gaokao', // 省 - 新高考报告
      'City-Data', // 省 - 大数据中心
      'City-System', // 省 - 阅卷帐号
      'City-Answer-Sheet-Production', // 省 - 答题卡制作
    ]
    const menus = JSON.parse(window.YJ_REGION_STORAGE.getItem("menus"));
    const list = []
    for (let index = 0; index < menus.length; index++) {
      const element = menus[index];
      // isShow：0表示新权限，1表示旧权限
      if (element.isShow === 1 || !filterList.includes(element.permCode)) continue
      list.push(element)
      if (element.children) {
        element.children = element.children.filter(item => item.isShow === 0 && item.type === 1)
      }
    }
    if (list.length === 0) {
      list.push({ permName: '答题卡制作', moduleUrl: '/v2/card/index' })
    }
    return list
  },
  getTodoSubjects: (subjectList) => {
    const resp = {
      success: true,
      body: []
    }
    if (subjectList.length > 0) {
      for (let index = 0; index < subjectList.length; index++) {
        const element = subjectList[index];
        resp.body.push({
          subjectId: element.id + '',
          subjectName: element.shortName
        })
      }
    }

    return resp
  },
}

export const networkData = {
  ossClient: null,
  initAliClient,
  getGradingType,
  getSubjects: (list) => {
    const subjectList = []
    for (const subject of list) {
      subjectList.push({
        id: subject.id,
        name: subject.shortName,
        subjectId: subject.subjectId,
        subjectName: subject.name
      })
    }
    return subjectList
  },
  getTodoQuestions: (list, pageNum) => {
    const toDoQuestions = [] // 存放questionNums的里元素
    const offset = 30
    for (let index = 0; index < list.length; index++) {
      const element = list[index];
      for (let cIndex = 0; cIndex < element.questionNums.length; cIndex++) {
        const ques = element.questionNums[cIndex];
        const target = ques.gradingTodo
        if (target) {
          ques.isError = ques.gradingTodo.score == -1
          const isImageArray = target.studentSheetRange && Array.isArray(target.studentSheetRange) && target.studentSheetRange.length > 0
          const imagesList = isImageArray ? target.studentSheetRange : []
          networkData.setQuesImagesList(imagesList, ques)
          for (let tIndex = 0; tIndex < ques.images.length; tIndex++) {
            const img = ques.images[tIndex];
            img.offset = offset
            const { src, rawWidth, rawHeight, rawX, rawY } = img
            img.expandUrl = img.src.replace('w_' + rawWidth, 'w_' + (rawWidth + offset * 2))
            img.expandUrl = img.expandUrl.replace('h_' + rawHeight, 'h_' + (rawHeight + offset * 2))
            img.expandUrl = img.expandUrl.replace('x_' + rawX, 'x_' + (rawX - offset))
            img.expandUrl = img.expandUrl.replace('y_' + rawY, 'y_' + (rawY - offset))
          }

          // 回填大小题号
          const stand = ques.stand
          if (stand) {
            ques.bigNum = stand.bigNum
            ques.smallNum = stand.smallNum
          }
          toDoQuestions.push(ques)
        }
      }
    }
    // toDoItem 组件需要数据结构，children 打分列表，current 当前列表项，本身代表第一个questionNums的里元素
    if (toDoQuestions.length === 0) {
      return { toDoQuestions, toDoItem: { stand: { point: 0 }, children: [], current: {} } }
    }
    const item = toDoQuestions[0]
    // 构造待打分的小题列表
    item.children = []
    // 合成当前题目的打分列表，如果是拆分小题，列表就是小题列表，否则列表里就他自己
    for (let index = 0; index < toDoQuestions.length; index++) {
      const element = toDoQuestions[index];
      if (element.isSplit) {
        for (let cIndex = 0; cIndex < element.questionSplitVos.length; cIndex++) {
          const child = element.questionSplitVos[cIndex];
          item.children.push({
            id: element.gradingTodo.id,
            question: child.splitQuestion,
            num: child.splitQuestion,
            updateGradingDetailSplitId: child.updateGradingDetailSplitId,
            images: element.images,
            gradingTodo: {
              id: element.gradingTodo.id,
              resultDetailId: element.gradingTodo.resultDetailId,
              score: element.gradingTodo.score == -1 ? "" : child.gradingScore,
              ossUrl: element.gradingTodo.ossUrl
            },
            stand: {
              point: child.splitScore
            }
          })
        }
      } else {
        item.children.push(item)
      }
    }
    item.current = item.children[0]
    return { toDoQuestions, toDoItem: item }
  },
  // 将抽样复评数据构造成和带批阅的数据结构一样
  getTodoQuestions2: (list) => {
    const toDoQuestions = []
    for (let cIndex = 0; cIndex < list.length; cIndex++) {
      const ques = list[cIndex];
      ques.isError = ques.score === -1
      const isImageArray = ques.studentSheetRange && Array.isArray(ques.studentSheetRange) && ques.studentSheetRange.length > 0
      const imagesList = isImageArray ? ques.studentSheetRange : []
      networkData.setQuesImagesList(imagesList, ques)
      // 初始化每个题待打分数集合
      ques.scores = []
      const fullScore = ques.point
      for (let sIndex = 1; sIndex <= fullScore; sIndex++) {
        ques.scores.push(sIndex)
      }
      ques.stand = { point: fullScore }
      ques.gradingTodo = { score: ques.score, resultId: ques.resultId }
    }
    return toDoQuestions
  },
  setQuesImagesList (imagesList, ques) {
    if (!ques.examMarkVos) {
      ques.examMarkVos = []
    }
    ques.images = []
    imagesList.forEach(item => {
      const list = item.ossUrl.split(";")
      for (let index = 0; index < list.length; index++) {
        const url = list[index];
        const ossItem = {
          rawWidth: 200,
          rawHeight: 200,
          src: url,
          pageIndex: item.pageIndex,
          scores: [] // 收集每张图被标记过的分数
        }
        if (url.indexOf('/crop,') === -1) continue
        const params = url.split("/crop,")[1].split(",");
        const widthPart = params.find(p => p.indexOf("w_") === 0)
        if (widthPart) {
          ossItem.rawWidth = Number(widthPart.split("_")[1])
        }
        const heightPart = params.find(p => p.indexOf("h_") === 0)
        if (heightPart) {
          ossItem.rawHeight = Number(heightPart.split("_")[1])
        }
        ques.images.push(ossItem)
      }
    })

    networkData.setImageMarks(ques, ques.examMarkVos)
  },
  setImageMarks (ques, examMarkVos) {
    for (let index = 0; index < ques.images.length; index++) {
      const item = ques.images[index];
      item.scores = []
      // 恢复read页面需要的标记数据结构
      const marks = examMarkVos.filter(item => item.noteIndex === index)
      for (let mIndex = 0; mIndex < marks.length; mIndex++) {
        const mark = marks[mIndex];
        const positions = mark.position.split(',')
        if (positions.length === 2) {
          const score = {
            value: mark.showScore,
            style: {
              left: positions[0] + 'px',
              top: positions[1] + 'px',
            },
            jsonUrl: mark.writingJsonUrl,
            svgUrl: mark.writingSvgUrl,
          }
          // 生成标记分画布对象Id，这里剔除整个图层记录
          if (!score.jsonUrl) {
            if (mark.showScore > 0) {
              score.type = 'add'
              score.id = `score_plus_${Math.round(positions[0])}_${Math.round(positions[1])}`
            } else {
              score.type = 'del'
              score.id = `score_minus_${Math.round(positions[0])}_${Math.round(positions[1])}`
            }
          }
          item.scores.push(score)
        }
      }
    }
  },
  getRoleMenus: body => {
    const dict = {
      FIRST: '正常卷批阅',
      SECOND: '仲裁卷评阅',
      THIRD: '三评',
      LEADER: '异常卷批阅'
    }
    const list = []
    const keys = Object.keys(dict)
    for (let index = 0; index < body.length; index++) {
      const { judgeType, readSize } = body[index];
      const item = { list: [] }
      item.id = keys.indexOf(judgeType) + 1
      item.label = dict[judgeType]
      item.size = readSize
      item.type = judgeType
      list.push(item)
    }
    return list
  },
  setExamMarkVos: async function (params, ques) {
    // 放在此位置，及时获取当前题目的给分情况，避免异步接口冲掉
    const showScore = ques.gradingTodo.score
    params.gradingMarks = []
    await networkData.initAliClient()
    for (let index = 0; index < ques.images.length; index++) {
      const img = ques.images[index];
      // 剔除标记格式
      const scores = img.scores.filter(item => !item.jsonUrl)
      let isRight = 0
      for (let cIndex = 0; cIndex < scores.length; cIndex++) {
        const score = scores[cIndex];
        const item = {
          showScore: score.value,
          isRight: score.type === 'add' ? 1 : 0,
          position: parseFloat(score.style.left) + ',' + parseFloat(score.style.top),
          noteIndex: index,
          pageIndex: img.pageIndex
        }
        isRight = item.isRight
        params.gradingMarks.push(item)
      }
      // 增加批注信息
      const itemCanvas = await networkData.getItemCanvas(img, params, index)
      if (itemCanvas) {
        // 第一个图层，并且没有打标记的情况，挂载上打的分值
        if (index === 0 && scores.length === 0) {
          itemCanvas.showScore = showScore
        }
        itemCanvas.isRight = isRight
        params.gradingMarks.push(itemCanvas)
      }
    }
  },
  setAssignTask: function (resp) {
    const {
      versionType, // 维度分配方式
      schools, // 参考学校
      quesMsgVos, // 试题列表
      isGrading, // 批阅状态
      ossUrl, // 试卷地址
      gradingVos, // 批阅任务列表
    } = resp.result;
    const task = {
      exam: {
        subjectName: resp.body.subjectName,
        examName: resp.body.examName,
        subjectCode: resp.body.subjectCode,
        grade: resp.body.gradeNum,
        id: resp.body.examId,
        teachers: resp.body.leaderTeachers,
        schools: resp.body.schools || resp.body.schoolsOfRegion
      }
    }
    // 分配方式
    const assignType = versionType === 2 ? 2 : 1;
    if (gradingVos.length === 0 && assignType === 1) {
      task.assignType = 1
    } else {
      task.assignType = versionType;
    }
    // 参考学校列表
    task.schoolList = schools;
    // 最高分
    const pointArr = quesMsgVos.map((item) => item.examStandVo.point);
    task.maxScore = Math.ceil(Math.max(...pointArr));
    task.isGrading = isGrading;
    task.ossUrl = ossUrl;
    const valuateTypes = ['', '单评', '双评', '三评']
    const assignTypes = ['平均分配', '效率优先', '--', '定额分配']
    // 批阅任务列表
    task.taskList = gradingVos.map((t) => {
      const question = quesMsgVos.find(
        (q) => q.examStandVo.question === t.gradingVos[0].question
      );
      return {
        ...t,
        evaluateType_zh: valuateTypes[t.evaluateType],
        assignType_zh: assignTypes[t.assignType],
        judgeType_zh: assignTypes[t.judgeType],
        nums: t.gradingVos.map((q) => (q.bigNum && q.smallNum) ? q.bigNum + '.' + q.smallNum : q.question).join(","),
        point: question ? question.examStandVo.point : 0,
      };
    });

    // 试题列表
    task.assignQuestionList = quesMsgVos.map((item) => {
      const ques = {
        id: item.id,
        isAllot: item.isAllot, // 是否已分配
        isAuto: item.isAuto, // 是否自动批阅
        isChecked: false, // 选择题号时使用
        ...item.examStandVo,
        images: [],
      }
      if (ques.standUrl) {
        const imgString = item.examStandVo.position
        imgString.split(";").forEach((item) => {
          ques.images.push(ques.standUrl + "?x-oss-process=image/crop," + item);
        });
      }
      return ques;
    });
    resp.task = task
  },
  setAssignTaskByTeacher: function (resp) {
    resp.body.exam = {
      subjectName: resp.body.subjectName,
      examName: resp.body.examName,
      subjectCode: resp.body.subjectCode,
      grade: resp.body.gradeNum,
      id: resp.body.examId,
      teachers: resp.body.leaderTeachers,
      schools: resp.body.schools || resp.body.schoolsOfRegion,
      assignType: 1,
      isGrading: resp.body.isGrading,
    }

    resp.body.subjectiveStands.forEach(item => {
      item.images = item.standRanges.map(s => s.ossUrl)
    })

  },
  setQuesProgressList: (res) => {
    const list = []
    for (let index = 0; index < res.body.length; index++) {
      const item = res.body[index]
      let progress = parseFloat(item.schedule)
      if (isNaN(progress)) {
        progress = 0
      }
      const evaluateTypes = ['DEFAULT', 'SINGLE', 'DOUBLE']
      item.evaluateType = evaluateTypes.indexOf(item.evaluateType)
      item.schoolId = item.regionId || item.schoolId
      const newItem = {
        raw: item,
        type: 'question',
        status: exam_enum.getCodeByKey(item.gradingStatus),
        title: '题号' + util.quesNumLabel(item),
        progress,
        subTitles: [
          '总分:' + item.score + '分'
        ],
        nums: [
          `任务量：${item.actualNum}`,
          `已批阅量：${item.read}`,
          `剩余批阅量：${item.remain}`,
          `异常卷量：${item.doubtTotal}`,
          `剩余异常卷：${item.doubtRemain}`,
          `仲裁量：${item.judgeTotal}`,
          `剩余仲裁量：${item.judgeRemain}`,
        ],
        tags: [
          {
            text: util.typeName('evaluateType', item.evaluateType),
            color: '#63bd67',
            backgroundColor: '#eafbea'
          },
          {
            text: util.typeName('assignType', item.assignType),
            color: '#f6566f',
            backgroundColor: '#fef0f0'
          },
          {
            text: util.typeName('assignVersion', item.assignVersion),
            color: '#e6a23c',
            backgroundColor: '#fdf6eb'
          }
        ],
        fold: {
          label: '学校进度',
          open: false,
          headers: [
            {
              key: 'schoolName',
              label: '学校名称'
            },
            {
              key: 'totalAssignNum',
              label: '分配任务量'
            },
            {
              key: 'read',
              label: '已批阅量'
            }, {
              key: 'remain',
              label: '待批阅量'
            },
            {
              key: 'teacherNum',
              label: '批阅教师数'
            },
            {
              key: 'onlineNum',
              label: '在线人数'
            }
          ]
        },
        mores: [
          {
            type: 'clear',
            label: '清空分数'
          }
        ]
      }
      list.push(newItem)
    }
    res.list = list
  },
  setSchoolProgressList: (res) => {
    const list = []
    for (let index = 0; index < res.body.length; index++) {
      const item = res.body[index]
      let progress = parseFloat(item.schedule)
      if (isNaN(progress)) {
        progress = 0
      }
      const evaluateTypes = ['DEFAULT', 'SINGLE', 'DOUBLE']
      item.evaluateType = evaluateTypes.indexOf(item.evaluateType)
      const newItem = {
        raw: item,
        type: 'school',
        status: item.isGrading,
        title: item.schoolName || '*学校已过期',
        progress,
        subTitles: [
          `批阅教师数：${item.teacherNum}`,
          `批阅教师在线数：${item.onlineNum}`
        ],
        nums: [
          `任务量：${item.totalAssignNum}`,
          `已批阅量：${item.read}`,
          `剩余批阅量：${item.remain}`
        ],
        tags: [
          {
            text: util.typeName('assignVersion', item.assignVersion),
            color: '#e6a23c',
            backgroundColor: '#fdf6eb'
          }
        ],
        fold: {
          label: '题块进度',
          open: false,
          headers: [
            {
              key: 'questionLabel',
              label: '题号'
            },
            {
              key: 'score',
              label: '满分'
            },
            {
              key: 'evaluateTypeName',
              label: '批阅方式'
            },
            {
              key: 'assignTypeName',
              label: '分配方式'
            },
            {
              key: 'totalAssignNum',
              label: '分配任务量'
            },
            {
              key: 'read',
              label: '已批阅量'
            },
            {
              key: 'remain',
              label: '待批阅量'
            },
            {
              key: 'judgeTotal',
              label: '仲裁量总计'
            },
            {
              key: 'judgeRemain',
              label: '剩余仲裁量'
            },
            {
              key: 'teacherNum',
              label: '批阅教师数'
            },
            {
              key: 'onlineNum',
              label: '在线人数'
            }
          ]
        },
        mores: []
      }
      list.push(newItem)
    }
    res.list = list
  },
  setProgressDetail: (res) => {
    const evaluateTypes = ['DEFAULT', 'SINGLE', 'DOUBLE']
    for (let index = 0; index < res.body.length; index++) {
      const element = res.body[index]
      element.schoolId = element.regionId || element.schoolId
      element.assignNum = element.totalAssignNum
      element.questionLabel = util.quesNumLabel(element)
      element.evaluateType = evaluateTypes.indexOf(element.evaluateType)
      element.evaluateTypeName = util.typeName('evaluateType', element.evaluateType)
      element.assignTypeName = util.typeName('assignType', element.assignType)
    }
  },
  setTeacherNameIfEmpty (list = []) {
    for (let index = 0; index < list.length; index++) {
      const element = list[index]
      if (!element.teacherName) {
        if (element.teacherId) {
          element.teacherName = element.teacherId.substring(element.teacherId.length - 6) + '(已删除)'
        } else {
          element.teacherName = '*已删除'
        }
      }
    }
  },
  getTodoTeacherList (items) {
    for (let index = 0; index < items.length; index++) {
      const element = items[index]
      element.teacherId = element.id
      element.teacherName = element.nickName
      element.roleNames = []
      const item = {
        schoolName: element.schoolName,
        teacherId: element.id,
        teacherName: element.nickName,
        tel: element.tel,
        todoGradingNum: 0,
        roleNames: []
      }
      for (let rIndex = 0; rIndex < element.teacherRoleVos.length; rIndex++) {
        const role = element.teacherRoleVos[rIndex]
        if (role) {
          if (element.roleNames.includes(name)) continue
          element.roleNames.push(role.schoolRoleVo.roleName)
        }
      }
    }
  },
  // 获取客观题得分
  getObjectivePoint (item) {
    // 未填写或无标准答案 0 分
    if (utilOld.isEmpty(item.answer) || !item.standAnswer) {
      return 0;
    } else if (item.answer === item.standAnswer) {
      // 答案全对得满分
      return item.point;
    } else if (item.multiChooseScoringPolicy) {
      // 判断标准答案是否包含填写答案
      let standAnswer = item.standAnswer.split("");
      let answer = Array.from(new Set(item.answer.split("")));
      const difference = answer.filter(v => standAnswer.includes(v))
      // 标准答案与填写答案合并去重
      let concatAnswer = Array.from(new Set(standAnswer.concat(answer)));
      // 是否不存在错误试题
      const isNoErrQuestion = standAnswer.length === concatAnswer.length
      // 是否存在正确试题
      const isCorrectQuestion = difference && difference.length > 0

      // 选不全得分
      if (item.multiChooseScoringPolicy === 'PARTIAL_CREDIT_SCORING') {
        // 如果标准答案长度与合并后长度一致且填写答案与标准答案长度一致，则为满分
        if (standAnswer.length === concatAnswer.length && standAnswer.length === answer.length) {
          return item.point;
        } else if (isNoErrQuestion) {
          return item.halfPoint;
        } else {
          return 0;
        }
      } else if (item.multiChooseScoringPolicy === 'OPTION_COMBINATION_SCORING') {
        // 组合得分
        let halfChoiceList = item.halfChoiceParam || [];
        if (item.standAnswer === item.answer) {
          return item.point;
        }
        let res = halfChoiceList.find(h => h.answer === item.answer);
        return res ? res.point : 0;
      } else if (item.multiChooseScoringPolicy === 'OPTION_SCORING') {
        // 选项得分
        if ((answer.length >= standAnswer.length && standAnswer !== answer) || !isNoErrQuestion || !isCorrectQuestion) {
          return 0
        } else {
          let halfChoiceParam = item.halfChoiceParam || {};
          return Math.min(difference.length * (halfChoiceParam.scorePerCorrectOption || 0), item.point)
        }
      } else if (item.multiChooseScoringPolicy === 'CLAUSE_PUNCTUATION_SCORING') {
        // 断句题型
        if (answer.length > (item.halfChoiceParam.deadlineOptionCount || 0) || !isCorrectQuestion) {
          return 0
        } else {
          let halfChoiceParam = item.halfChoiceParam || {};
          return Math.min(difference.length * (halfChoiceParam.scorePerCorrectOption || 0), item.point)
        }
      }
    }
  },
  // 获得客观题答案样式
  getObjectiveAnswerStyle (item) {
    let background = '#FF4C3B'
    // 无答案直接返回
    if (!utilOld.isEmpty(item.answer)) {
      if (item.standAnswer === item.answer) {
        // 单选或者多选答案全对则返回正确颜色
        background = ''
      } else if (item.multiChooseScoringPolicy) {
        // 判断标准答案是否包含填写答案
        let standAnswer = item.standAnswer.split("");
        let answer = Array.from(new Set(item.answer.split("")));
        const difference = answer.filter(v => standAnswer.includes(v))
        // 标准答案与填写答案合并去重
        let concatAnswer = Array.from(new Set(standAnswer.concat(answer)));
        // 是否存在错误试题
        const isErrQuestion = standAnswer.length !== concatAnswer.length
        // 是否存在正确试题
        const isCorrectQuestion = difference && difference.length > 0
        // 选不全得分
        if (item.multiChooseScoringPolicy === 'PARTIAL_CREDIT_SCORING') {
          // 如果标准答案长度与合并后长度一致且填写答案与标准答案长度一致，则为满分
          if (standAnswer.length === concatAnswer.length && standAnswer.length === answer.length) {
            background = "";
          } else if (!isErrQuestion) {
            background = '#f88e05';
          }
        } else if (item.multiChooseScoringPolicy === 'OPTION_COMBINATION_SCORING') {
          // 组合得分
          let halfChoiceList = item.halfChoiceParam || [];
          let res = halfChoiceList.find(h => h.answer === item.answer);
          background = res ? '#f88e05' : '#FF4C3B';
        } else if (item.multiChooseScoringPolicy === 'OPTION_SCORING') {
          // 选项得分
          if ((answer.length >= standAnswer.length && standAnswer !== answer) || isErrQuestion || !isCorrectQuestion) {
            background = '#FF4C3B'
          } else {
            background = '#f88e05'
          }
        } else if (item.multiChooseScoringPolicy === 'CLAUSE_PUNCTUATION_SCORING') {
          // 断句题型
          if (!isCorrectQuestion || (answer.length > item.halfChoiceParam.deadlineOptionCount || 0)) {
            background = '#FF4C3B'
          } else {
            background = '#f88e05'
          }
        }
      }
    }

    return {
      background: background
    }
  },
  getItemCanvas: async function (img, params, index) {
    if (img.canvas && networkData.ossClient) {
      xDraw.exportFile(img)
      // 上传文件
      if (img.svgFile) {
        const item = {
          showScore: 0,
          isRight: 0,
          position: '0,0',
          noteIndex: index,
          pageIndex: img.pageIndex,
        }
        const nowDate = new Date()
        const year = nowDate.getFullYear();
        const month = (nowDate.getMonth() + 1).toString().padStart(2, '0');
        const fileName = `/exam/mark/${year}${month}/${params.examId}/pizhu/${params.gradingType}_${params.teacherId}_${params.detailId}_${img.pageIndex}_${index}`
        item.writingSvgUrl = await networkData.uploadFile(fileName + '.svg', img.svgFile)
        item.writingJsonUrl = await networkData.uploadFile(fileName + '.json', img.jsonFile)
        return item
      }
    }
    return null
  },
  uploadFile: async function (fileName, file) {
    const result = await networkData.ossClient.multipartUpload(fileName, file)
    if (result.res) {
      const urls = result.res.requestUrls
      if (urls && urls.length > 0) {
        const url = (urls[0]).split('?')[0]
        return url
      }
    } else {
      return String(result)
    }
  },
  // 获取分数等级比
  getScoreLevelRatio (type) {
    const scoreLevelRatioDict = {
      A: 0.85,
      B: 0.75,
      C: 0.6,
      D: 0.3,
      E: 0,
    }

    return scoreLevelRatioDict[type]
  },
  // 获取阅卷质量
  getReadQuality (resp) {
    const obj = {
      code: 200,
      result: {
        date: Date.now(),
        avgChart: {},
        statisticsTable: {
          statisticsRows: []
        },
      }
    }
    if (resp.body && resp.body.length) {
      // 教师名称分组添加进 avgChart teacherId='--' 为总数
      // 图表信息
      networkData.setTeacherNameIfEmpty(resp.body)
      const summary = resp.body.find(s => s.teacherId === '--')
      obj.result.avgChart.avgScore = summary ? summary.avgScore : 0
      const teacherScore = []
      const statisticsRows = resp.body.filter(s => s.teacherId != '--')
      statisticsRows.forEach(teacher => {
        teacherScore.push({
          teacherId: teacher.teacherId,
          teacherName: teacher.teacherName,
          avgScore: teacher.avgScore,
        })

        let row = teacher
        row.teacherType = getGradingType(teacher.teacherType)
        row.alreadyCount = teacher.readOverCount
        row.totalCount = teacher.assignCount
        row.avgGradingTime = teacher.gradingTime
        obj.result.statisticsTable.statisticsRows.push(row)
      });

      obj.result.avgChart.teacherScore = teacherScore
    }
    return obj
  },
  getScoreSpread (resp) {
    const obj = {
      code: 200,
      result: {
        date: Date.now(),
        distribution_curve: [],
        distribution_table: [],
        score_group: []
      }
    }
    if (resp.body && resp.body.length) {
      networkData.setTeacherNameIfEmpty(resp.body)
      resp.body.forEach(item => {
        item.teacherType = getGradingType(item.teacherType)
      })
      const all = resp.body[0]
      for (let index = 0; index < all.scoreScopes.length; index++) {
        const element = all.scoreScopes[index];
        obj.result.distribution_curve.push({ count: element.count, group: [element.start, element.end] })
        obj.result.score_group.push([element.start, element.end])
      }
      for (let index = 0; index < resp.body.length; index++) {
        const element = resp.body[index];
        element.counts = []
        for (let cIndex = 0; cIndex < element.scoreScopes.length; cIndex++) {
          const child = element.scoreScopes[cIndex];
          element.counts.push(child.count)
        }
        obj.result.distribution_table.push(element)
      }
    }
    return obj
  }
}

export const examData = {
  getQuerys: (all) => {
    const list = [
      {
        name: '考试状态',
        key: 'status',
        list: [
          {
            name: '已结束',
            value: true
          },
          {
            name: '进行中',
            value: false
          }
        ]
      },
      {
        name: '考试类型',
        key: 'type',
        list: [
          {
            code: 1,
            name: '学前测试',
            value: 'ENTRANCE'
          },
          {
            code: 2,
            name: '周测',
            value: 'WEEK'
          },
          {
            code: 3,
            name: '单元测试',
            value: 'UNIT'
          },
          {
            code: 4,
            name: '月考',
            value: 'MONTH'
          },
          {
            code: 5,
            name: '期中考试',
            value: 'MIDTERM'
          },
          {
            code: 6,
            name: '期末考试',
            value: 'END_OF_TERM'
          },
          {
            code: 7,
            name: '模拟考试',
            value: 'SIMULATION'
          },
          {
            code: 8,
            name: '其他',
            value: 'OTHER'
          },
        ]
      },
      {
        name: '阅卷方式',
        key: 'mark',
        list: [
          {
            code: 0,
            name: '网络',
            value: 'NETWORK'
          },
          {
            code: 1,
            name: '导入',
            value: 'IMPORT'
          },
          // {
          //   code: 2,
          //   name: '在线',
          //   value: 'ONLINE'
          // },
          // {
          //   code: 3,
          //   name: '制卡',
          //   value: 'SHEET'
          // },
          {
            code: 4,
            name: '有痕',
            value: 'IS_HEN'
          }
        ]
      },
      {
        name: '考试时间',
        key: 'date',
        list: [
          {
            name: '本周',
            value: 'WEEK'
          },
          {
            name: '上周',
            value: 'LAST_WEEK'
          },
          {
            name: '本月',
            value: 'MONTH'
          },
          {
            name: '上月',
            value: 'LAST_MONTH'
          },
          {
            name: '近半年',
            value: 'HALF_YEAR'
          }
        ]
      },
    ]
    if (all) {
      for (let index = 0; index < list.length; index++) {
        const element = list[index];
        element.list.unshift({ name: '全部', value: "" })
      }
    }
    return list
  },
  // 获取指定考试属性的枚举列表
  getQueryItems (name, all) {
    const list = examData.getQuerys(all)
    const items = list.find(item => item.name === name)
    return items || []
  },
  // 获取疑问项
  getDoubts () {
    return [
      {
        id: "OBJ_DOUBT",
        type: 5,
        name: "客观题疑问",
        total: 0
      },
      {
        id: "OBJ_NOT_OBVIOUS",
        type: 10,
        name: "填涂不明显",
        total: 0
      },
      {
        id: "OBJ_BLANK_ONLY_CHECK",
        type: 12,
        name: "选项为空",
        total: 0
      },
      {
        id: "OBJ_ONE_MORE_ANSWER",
        type: 13,
        name: "单选变多选",
        total: 0
      },
      {
        id: "SUB_DOUBT",
        type: 6,
        name: "主观题疑问",
        total: 0
      },
      {
        id: "OBJ_OTHER",
        type: 11,
        name: "其他",
        total: 0
      },
    ]
  },
  setToDoQuestionStand (resp) {
    if (resp.success && resp.body) {
      // 转换试题类型
      resp.body.examStandVos.forEach(element => {
        element.choiceTypeCode = exam_enum.getCodeByKey(element.choiceType)
      })

      // 转换类型
      if (resp.body.examBase) {
        resp.body.examBase.typeDesc = exam_enum.getDescByKey(resp.body.examBase.type)
        resp.body.examBase.standConfirmCode = exam_enum.getCodeByKey(resp.body.examBase.standConfirm)
        resp.body.examBase.hasPaper = exam_enum.getCodeByKey(resp.body.examBase.hasPaper)
      }

      // 转换批阅状态
      resp.body.isGrading = util.isEmpty(resp.body.gradingStatus) ? -1 : exam_enum.getCodeByKey(resp.body.gradingStatus)

      // 转换试题坐标
      resp.body.examStandVos.forEach(element => {
        element.templatePositionList = []
        element.templatePointPositionList = []
        if (resp.body.examStandStates && resp.body.examStandStates.length > 0) {
          resp.body.examStandStates.forEach(template => {
            // 当前模板坐标
            const templatePosition = {
              templateNum: template.templateNum,
              positionList: [],
              optionList: [],
            }

            // 检测是否存在选项坐标
            if (element.etcs) {
              const optionPosition = element.etcs[template.templateNum]
              if (optionPosition) {
                templatePosition.optionList = util.optionCoordinateAnalysis(optionPosition)
              }
            }

            // 检测是否存在框选坐标
            if (element.templatePositions) {
              const position = element.templatePositions[template.templateNum]
              if (position) {
                templatePosition.positionList = util.coordinateListAnalysis(position)
              } else {
                templatePosition.positionList.push([{ x: 10, y: 10, w: 10, h: 10 }])
              }
            }

            if (element.choiceTypeCode === 2) {
              // 当前模板坐标
              const templatePointPosition = {
                templateNum: template.templateNum,
                pointPositionList: [],
              }

              // 检测是否存在登分框坐标
              if (element.templatePointPositions) {
                const position = element.templatePointPositions[template.templateNum]
                if (position) {
                  templatePointPosition.pointPositionList.push({
                    ...util.coordinateAnalysis(position),
                    optionList: templatePosition.optionList
                  })
                }
              }
              element.templatePointPositionList.push(templatePointPosition)
            }
            element.templatePositionList.push(templatePosition)
          })
        }
      });
    }
  }
}

export const reportData = {
  // 获取六率配置
  getSixRate () {
    return [
      {
        code: 0,
        name: '高分率',
        value: 'wonderRate'
      },
      {
        code: 1,
        name: '优秀率',
        value: 'excelRate'
      },
      {
        code: 2,
        name: '良好率',
        value: 'goodRate'
      },
      {
        code: 3,
        name: '合格率',
        value: 'passRate'
      },
      {
        code: 4,
        name: '学困率',
        value: 'tiredRate'
      },
      {
        code: 5,
        name: '学弱率',
        value: 'feebleRate'
      },
    ]
  },

  // 获取导出报告配置
  getExportReportConfig () {
    return [
      {
        name: '单校行政',
        key: 'singleSchool',
        list: [
          {
            name: '一键下载',
            value: "SCHOOL_SINGLE_REPORT_ZIP"
          },
          {
            name: '班级报告',
            value: "CLASS_MERGE"
          },
          {
            name: '年级成绩单',
            value: "GRADE_SCORE"
          },
          {
            name: '基础指标分析',
            value: "GRADE_SINGLE_SIX_RATE"
          },
          {
            name: '小题分报表',
            value: "SCHOOL_QUESTION_SCORE_DETAIL",
          },
          {
            name: '小题对比分析',
            value: "SCHOOL_QUESTION_CONTRASTIVE_ANALYSIS",
          },
          {
            name: '题型分析',
            value: "GRADE_PATTERN"
          },
        ]
      },
      {
        name: '单校教学',
        key: 'singleSchoolTeach',
        list: [
          {
            name: '一键下载',
            value: "TEACH_SCHOOL_SINGLE_REPORT_ZIP"
          },
          {
            name: '班级报告',
            value: "TEACH_CLASS_MERGE"
          },
          {
            name: '年级成绩单',
            value: "TEACH_GRADE_SCORE"
          },
          {
            name: '基础指标分析',
            value: "TEACH_GRADE_SINGLE_SIX_RATE"
          },
          {
            name: '小题分报表',
            value: "TEACH_SCHOOL_QUESTION_SCORE_DETAIL",
          }
        ]
      },
      {
        name: '多科校级',
        key: 'multipleSchool',
        list: [
          {
            name: '单校多科一键下载',
            value: "SCHOOL_MULTIPLE_ZIP"
          },
          {
            name: '单校多科平均分统计报告',
            value: "SCHOOL_MULTIPLE_AVERAGE_SCORE"
          },
          {
            name: '汇总分数段统计',
            value: "SCHOOL_MULTIPLE_SCORE_SECTION"
          },
          {
            name: '六率分析',
            value: "SCHOOL_MULTIPLE_SIX_RATE"
          },
          {
            name: '单校多科年级成绩单',
            value: "SCHOOL_MULTIPLE_SCORE_RANKING",
          },
        ]
      },
      {
        name: '高考汇总',
        key: 'gaokaoSummary',
        list: [
          {
            name: '学生成绩单',
            newVersion: false,
            value: "REGION_NCEE_SUMMARY_REPORT_CARD_ZIP"
          },
          {
            name: '分数段占比',
            newVersion: false,
            value: "REGION_NCEE_SUMMARY_SECTION_COMPARISON"
          },
          {
            name: '名次段占比',
            newVersion: false,
            value: "REGION_NCEE_SUMMARY_RANKING_SECTION_COMPARISON"
          },
          {
            name: '基础成绩统计',
            newVersion: false,
            value: "REGION_NCEE_SUMMARY_SIX_RATE"
          },
          {
            name: '临界生统计',
            newVersion: false,
            value: "REGION_NCEE_SUMMARY_CRITICAL_STUDENT",
          },
          {
            name: '临界生详情',
            newVersion: false,
            value: "REGION_NCEE_SUMMARY_CRITICAL_STUDENT_DETAIL",
          },
          {
            name: '试题分析',
            newVersion: false,
            value: "REGION_NCEE_SUMMARY_QUESTION_ANALYSIS_ZIP"
          },
        ]
      },
      {
        name: '高考主科',
        key: 'gaokaoMain',
        list: [
          {
            name: '分数段占比',
            newVersion: false,
            value: "REGION_NCEE_MAIN_SECTION_COMPARISON"
          },
          {
            name: '名次段占比',
            newVersion: false,
            value: "REGION_NCEE_MAIN_RANKING_SECTION_COMPARISON"
          },
          {
            name: '临界生统计',
            newVersion: false,
            value: "REGION_NCEE_MAIN_CRITICAL_STUDENT"
          },
          {
            name: '基础成绩统计',
            newVersion: false,
            value: "REGION_NCEE_MAIN_SIX_RATE"
          },
        ]
      },
      {
        name: '高考物理',
        key: 'gaokaoScience',
        list: [
          {
            name: '成绩单',
            newVersion: false,
            value: "REGION_NCEE_SCIENCE_REPORT_CARD_ZIP"
          },
          {
            name: '分数段占比',
            newVersion: false,
            value: "REGION_NCEE_SCIENCE_SECTION_COMPARISON"
          },
          {
            name: '名次段占比',
            newVersion: false,
            value: "REGION_NCEE_SCIENCE_RANKING_SECTION_COMPARISON"
          },
          {
            name: '基础成绩统计',
            newVersion: false,
            value: "REGION_NCEE_SCIENCE_SIX_RATE"
          },
          {
            name: '上线统计',
            newVersion: true,
            value: "REGION_NCEE_SCIENCE_LINE_SCORE_ANALYSIS"
          },
        ]
      },
      {
        name: '高考历史',
        key: 'gaokaoArt',
        list: [
          {
            name: '成绩单',
            newVersion: false,
            value: "REGION_NCEE_ART_REPORT_CARD_ZIP"
          },
          {
            name: '分数段占比',
            newVersion: false,
            value: "REGION_NCEE_ART_SECTION_COMPARISON"
          },
          {
            name: '名次段占比',
            newVersion: false,
            value: "REGION_NCEE_ART_RANKING_SECTION_COMPARISON"
          },
          {
            name: '基础成绩统计',
            newVersion: false,
            value: "REGION_NCEE_ART_SIX_RATE"
          },
          {
            name: '上线统计',
            newVersion: true,
            value: "REGIONL_NCEE_ART_LINE_SCORE_ANALYSIS"
          },
        ]
      },
      {
        name: '省级高考汇总',
        key: 'provinceGaokaoSummary',
        list: [
          {
            name: '汇总区县基础指标分析',
            newVersion: false,
            value: "CITY_NCEE_SUMMARY_REGION_SIX_RATE"
          },
          {
            name: '汇总成绩单',
            newVersion: false,
            value: "REGION_NCEE_SUMMARY_REPORT_CARD_ZIP"
          },
          {
            name: '汇总基础指标分析',
            newVersion: false,
            value: "REGION_NCEE_SUMMARY_SIX_RATE"
          },
          {
            name: '汇总临界生',
            newVersion: false,
            value: "CITY_NCEE_SUMMARY_CRITICAL_STUDENT"
          },
          {
            name: '汇总名次占比',
            newVersion: false,
            value: "CITY_NCEE_SUMMARY_RANKING_SECTION_COMPARISON",
          },
          {
            name: '汇总分数段占比',
            newVersion: false,
            value: "CITY_NCEE_SUMMARY_SECTION_COMPARISON",
          },
        ]
      },
      {
        name: '省级高考主科',
        key: 'provinceGaokaoMain',
        list: [
          {
            name: '主科区县基础指标分析',
            newVersion: false,
            value: "CITY_NCEE_MAIN_REGION_SIX_RATE"
          },
          {
            name: '主科基础指标分析',
            newVersion: false,
            value: "REGION_NCEE_MAIN_SIX_RATE"
          },
          {
            name: '主科临界生',
            newVersion: false,
            value: "CITY_NCEE_MAIN_CRITICAL_STUDENT"
          },
          {
            name: '主科名次占比',
            newVersion: false,
            value: "CITY_NCEE_MAIN_RANKING_SECTION_COMPARISON"
          },
          {
            name: '主科分数段占比',
            newVersion: false,
            value: "CITY_NCEE_MAIN_SECTION_COMPARISON"
          },
        ]
      },
      {
        name: '省级高考物理',
        key: 'provinceGaokaoScience',
        list: [
          {
            name: '物理类基础指标分析',
            newVersion: false,
            value: "REGION_NCEE_SCIENCE_SIX_RATE"
          },
          {
            name: '物理类成绩单',
            newVersion: false,
            value: "REGION_NCEE_SCIENCE_REPORT_CARD_ZIP"
          },
          {
            name: '物理类分数段占比',
            newVersion: false,
            value: "REGION_NCEE_SCIENCE_SECTION_COMPARISON"
          },
          {
            name: '物理类名次占比',
            newVersion: false,
            value: "REGION_NCEE_SCIENCE_RANKING_SECTION_COMPARISON"
          },
        ]
      },
      {
        name: '省级高考历史',
        key: 'provinceGaokaoArt',
        list: [
          {
            name: '历史类基础指标分析',
            newVersion: false,
            value: "REGION_NCEE_ART_SIX_RATE"
          },
          {
            name: '历史类成绩单',
            newVersion: false,
            value: "REGION_NCEE_ART_REPORT_CARD_ZIP"
          },
          {
            name: '历史类分数段占比',
            newVersion: false,
            value: "REGION_NCEE_ART_SECTION_COMPARISON"
          },
          {
            name: '历史类名次占比',
            newVersion: false,
            value: "REGION_NCEE_ART_RANKING_SECTION_COMPARISON"
          }
        ]
      }

    ]
  },

  // 获取指定配置属性的枚举列表
  getQueryItems (name) {
    const list = reportData.getExportReportConfig()
    const items = list.find(item => item.name === name)
    return items || []
  },
}

export const cardData = {
  getCardTypes () {
    return [
      {
        name: 'PC制卡',
        value: 'SYSTEM_SHEET'
      },
      {
        name: '第三方裁切',
        value: 'THIRD_SHEET'
      },
      {
        name: '题库制卡',
        value: 'ZU_JUAN_SHEET'
      }
    ]
  },
  getFormats () {
    return [
      {
        name: 'A3',
        value: 'A3'
      },
      {
        name: 'A4',
        value: 'A4'
      },
      {
        name: 'A8',
        value: 'A8'
      }
    ]
  },
  getHens () {
    return [
      {
        name: '网络',
        value: 'NON_WRITING'
      },
      {
        name: '有痕',
        value: 'WRITING'
      }
    ]
  },
  getSteps () {
    return [
      {
        stepNum: 1,
        id: 1,
        name: '确认正反面',
        desc: '请调整试卷角度，按住鼠标左键拖动矩形<b>框选试卷正面位置</b>',
        boxType: 'front',
        positions: []
      },
      {
        stepNum: 2,
        id: 2,
        name: '框选定位区',
        desc: '请框选试卷的一行文字作为文字定位区，正反面均需框选',
        boxType: 'front',
        demos: [
          {
            name: '正面定位区',
            value: require('../assets/images/正面定位框选.gif')
          },
          {
            name: '反面定位区',
            value: require('../assets/images/反面定位框选.gif')
          }
        ],
        positions: []
      },
      {
        stepNum: 3,
        id: 3,
        name: '框选考号区',
        desc: '请按住鼠标左键拖动矩形框选学生考号；若框选错误，点击鼠标右键“删除”，然后再重新框选',
        boxType: 'EXAM_NO', // EXAM_NO
        positions: [],
      },
      {
        stepNum: 4,
        id: 4,
        name: '框选答题区',
        desc: '请按住鼠标左键拖动矩形<b>框选客观题</b>；若框选错误，点击鼠标右键“删除”，然后再重新框选；若需要调整框选大小位置，请点击编辑',
        boxType: 'obj-ques', // obj-ques、sub-ques
        positions: []
      },
      {
        stepNum: 5,
        id: 5,
        name: '其他设置',
        desc: '',
        desc1: '请框选试卷上的缺考标记填涂区；此为可选操作，如无需识别标记缺考则可不框选；若框选错误，点击鼠标右键“删除”，然后再重新框选;',
        desc2: '请按住鼠标左键拖动矩形框选学生信息(班级、学号、姓名、考场、座次、考号等)用于批阅过程中遮盖学生信息；若框选错误，点击鼠标右键“删除”，然后再重新框选;',
        boxType: 'box-quekao', // box-quekao, box-zhegai
        demos: [
          {
            name: '缺考标记',
            value: require('../assets/images/缺考说明.jpg')
          },
          {
            name: '学生信息',
            value: require('../assets/images/学生信息.png')
          }
        ],
        positions: []
      }
    ]
  },
  getMutilSteps () {
    return [
      {
        stepNum: 1,
        id: 2,
        name: '框选定位区',
        desc: '<span style="color: #F14848;">每一页均需框选定位区；</span>若框选错误，单击“删除”或“鼠标右键”，然后再重新框选',
        boxType: 'front',
        demos: [
          {
            name: '正面定位区',
            value: require('../assets/images/正面定位框选.gif')
          },
          {
            name: '反面定位区',
            value: require('../assets/images/反面定位框选.gif')
          }
        ],
        positions: [],
        guide: `<p class="guide-sub-title">框选定位区</p>
          <p class="guide-desc">每一页均需要框选定位区；</p>
          <p class="guide-desc">请选择一行文字为定位区；</p>
          <p class="guide-desc">每一页选择不同的文字作为定位区；</p>
          <p class="guide-desc">不可选择定位点。</p>
          <p class="guide-color"><span style="background-color: #FF8038;"></span>橙色代表定位区框选区域。</p>`,
      },
      {
        stepNum: 2,
        id: 3,
        name: '框选考号区',
        desc: '<span style="color: #F14848;">每一张正面均需框选考号；</span>若框选错误，点击鼠标右键“删除”，然后再重新框选',
        boxType: 'EXAM_NO', // EXAM_NO
        positions: [],
        guide: `<p class="guide-sub-title">框选考号区</p>
          <p class="guide-desc">1种考号：</p>
          <p class="guide-desc">选择填涂类型后，再框选；</p>
          <p class="guide-desc">可直接重新框选识别框；</p>
          <p class="guide-desc">右键可删除识别框；</p>
          <p class="guide-desc">2种考号：</p>
          <p class="guide-desc">请先完成第1种考号框选，再选择第2</p>
          <p class="guide-desc">种考号类型，再进行框选。</p>
          <p class="guide-color"><span style="background-color: #00BA4A;"></span>绿色代表框选考号区。</p>`,
      },
      {
        stepNum: 3,
        id: 4,
        name: '框选客观题',
        desc: '请按住鼠标左键拖动矩形框选客观题；若框选错误，点击鼠标右键“删除”，然后再重新框选；若需要调整框选大小位置，请点击编辑',
        boxType: 'obj-ques', // obj-ques、sub-ques
        positions: [],
        guide: `<p class="guide-sub-title">框选客观题</p>
          <p class="guide-desc">支持按组框选；</p>
          <p class="guide-desc">不支持框选题号；</p>
          <p class="guide-desc">请仔细检查识别框是否紧贴选项。</p>
          <p class="guide-color"><span style="background-color: #2877FF;"></span>蓝色代表框选客观题。</p>`,
      },
      {
        stepNum: 4,
        id: 4,
        name: '框选主观题',
        desc: '请按住鼠标左键拖动矩形框选主观题；若框选错误，点击鼠标右键“删除”，然后再重新框选；若需要调整框选大小位置，请点击编辑',
        boxType: 'sub-ques', // obj-ques、sub-ques
        positions: [],
        guide: `<p class="guide-sub-title">框选主观题</p>
          <p class="guide-desc">提前和阅卷老师确认批阅方式，再进</p>
          <p class="guide-desc">行框选。</p>
          <p class="guide-color"><span style="background-color: #2877FF;"></span>蓝色代表框选主观题。</p>`,
      },
      {
        stepNum: 5,
        id: 5,
        name: '其他设置',
        desc: '',
        desc1: '每一页均需框选，如无页码可框选其他不一样文字。若框选错误，点击鼠标右键“删除”，然后再重新框选;',
        desc2: '请框选试卷上的缺考标记填涂区；此为可选操作，如无需识别标记缺考则可不框选；若框选错误，点击鼠标右键“删除”，然后再重新框选;',
        desc3: '请按住鼠标左键拖动矩形框选学生信息(班级、学号、姓名、考场、座次、考号等)用于批阅过程中遮盖学生信息；若框选错误，点击鼠标右键“删除”，然后再重新框选;',
        boxType: 'box-page', // box-page box-quekao, box-zhegai
        demos: [
          {
            name: '框选页码',
            value: require('../assets/images/缺考说明.jpg')
          },
          {
            name: '缺考标记',
            value: require('../assets/images/缺考说明.jpg')
          },
          {
            name: '学生信息',
            value: require('../assets/images/学生信息.png')
          }
        ],
        positions: [],
        guide: `<p class="guide-sub-title">框选页码</p>
          <p class="guide-desc">每一页均需要框选页码，如无页码可</p>
          <p class="guide-desc">框选其他不一样的文字。</p>
          <p class="guide-sub-title">缺考标记</p>
          <p class="guide-desc">请根据实际情况，决定是否框选缺考</p>
          <p class="guide-desc">标记。</p>
          <p class="guide-sub-title">遮盖学生信息</p>
          <p class="guide-desc">遮盖的信息，在批阅过程中，批阅教</p>
          <p class="guide-desc">师查看原卷时，将无法查看被遮盖的</p>
          <p class="guide-desc">信息，保证批阅公正性。</p>
          <p class="guide-color"><span style="background-color: #FF8038;"></span>橘黄色代表框选页码信息。</p>
          <p class="guide-color"><span style="background-color: #904CFF;"></span>紫色代表框选缺考信息。</p>
          <p class="guide-color"><span style="background-color: #00BA4A;"></span>绿色代表框选学生信息。</p>`,
      }
    ]
  },
  getImageActions () {
    return [
      {
        icon: 'rotate90',
        offset: 90,
        method: 'rotate',
        tip: '右转90°',
        className: 'tool1'
      },
      {
        icon: 'rotate1-',
        offset: -1,
        method: 'rotate',
        tip: '左转1°',
        className: 'tool1'
      },
      {
        icon: 'rotate1+',
        offset: 1,
        method: 'rotate',
        tip: '右转1°',
        className: 'tool1'
      },
      {
        icon: 'smaller',
        offset: -0.1,
        method: 'resize',
        tip: '缩小10%'
      },
      {
        icon: 'bigger',
        offset: 0.1,
        method: 'resize',
        tip: '放大10%'
      }
    ]
  },
  getStep3Types () {
    return [
      { name: '填涂学生考号', value: 'EXAM_NO', newValue: 'NUMBER_FILL_AREA' },
      { name: '二维码', value: 'QR_CODE', newValue: 'QR_CODE' },
      { name: '条形码', value: 'BAR_CODE', newValue: 'BARCODE' },
      { name: '手写考号', value: 'HANDWRITTEN_NUMBERAL', newValue: 'HANDWRITTEN_NUMBER' }
    ]
  }
}

async function initAliClient () {
  if (!networkData.ossClient) {
    const opt = await baseApi.getSTSToken()
    networkData.ossClient = new AliOSS(opt)
  }
}

function getGradingType (type) {
  const markTypeDict = {
    FIRST: '1',
    SECOND: '2',
    THIRD: '3',
    LEADER: '4'
  }
  return markTypeDict[type] || '0'
}



// WEBPACK FOOTER //
// ./src/v2/utils/data.js